module.exports = __webpack_public_path__ + "static/media/Passport.1a7c8568.png";